import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { IconsEnum } from '@uigy/generated/icons.enum';
import { IconComponent } from '@uigy/shared/components/icons/icon/icon.component';
import { ColorStatus } from '@uigy/shared/components/ui-status-pill/ui-status-pill.enums';

@Component({
  selector: 'app-ui-status-pill',

  imports: [
    NgClass,
    IconComponent
  ],
  templateUrl: './ui-status-pill.component.html',
  styleUrl: './ui-status-pill.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiStatusPillComponent {
  public color: InputSignal<ColorStatus> = input.required<ColorStatus>();
  public label: InputSignal<string> = input.required<string>();
  public icon: InputSignal<IconsEnum> = input.required<IconsEnum>();
}
